import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  role: 'owner' | 'editor' | 'viewer';
  tenant: { id: number; name: string; slug: string };
}

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  setSession: (token: string, user: AuthUser) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      reset: () => set({ token: null, user: null }),
    }),
    { name: 'vinacora-auth' },
  ),
);
